import { render, staticRenderFns } from "./ArtifactManageOnlyRead.vue?vue&type=template&id=321a6443&scoped=true&"
import script from "./ArtifactManageOnlyRead.vue?vue&type=script&lang=js&"
export * from "./ArtifactManageOnlyRead.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactManageOnlyRead.vue?vue&type=style&index=0&id=321a6443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a6443",
  null
  
)

export default component.exports